<sdps-modal id='edit-employee-modal' [sdpsTitle]="title" class="sdps-custom-modal" [size]="'flex--medium'" (close)="closeModal()" aria-label="Edit Employee Modal">
  <div slot="modal-body">
    <form class="container" [formGroup]="editRequestsForm">
      <sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none" *ngIf="(editRequestsForm.get('employeeFirstName').value && editRequestsForm.get('employeeFirstName').invalid) ||
          (editRequestsForm.get('employeeLastName').value && editRequestsForm.get('employeeLastName').invalid) ||
          (serviceErrorMsg) || (editRequestsForm.get('employeeId').value && invalidEmpId) ||
          (editRequestsForm.get('employeeFirstName').invalid && editRequestsForm.get('employeeFirstName').errors.required && sharedService.addOrEditEmployee !== 'addEployee') ||
          (editRequestsForm.get('employeeLastName').invalid && editRequestsForm.get('employeeLastName').errors.required && sharedService.addOrEditEmployee !== 'addEployee')">
        <div id="sdpsErrorNotificationText" class="sdps-notification__text" *ngIf="sharedService.addOrEditEmployee === 'addEployee'" class="sdps-text-l-body">
          <p *ngIf="editRequestsForm.get('employeeId').value && invalidEmpId">
            {{getSharedConstant.textFieldErrorMsg.employeeIdErrorMsg}}
          </p>
          <p *ngIf="serviceErrorMsg" [innerHTML]="serviceErrorMsg"></p>
        </div>
        <div class="sdps-notification__text" id="sdpsErrorNotificationText" *ngIf="sharedService.addOrEditEmployee !== 'addEployee' && !serviceErrorMsg">
          <p [innerHTML]="getSharedConstant.pleaseCorrectFollowingError"></p>
          <ul class="sdps-navigation--horizontal__list error-list">
            <li *ngIf="invalidEmpId" [innerHTML]="getSharedConstant.textFieldErrorMsg.employeeIdErrorMsg"></li>
            <li
              *ngIf="editRequestsForm.get('employeeFirstName').invalid && editRequestsForm.get('employeeFirstName').errors.required"
              [innerHTML]="getSharedConstant[businessUnit].employeeOrParticipantFirstNameRequiredMsg"></li>
            <li
              *ngIf="editRequestsForm.get('employeeFirstName').invalid && editRequestsForm.get('employeeFirstName').errors.maxlength"
              [innerHTML]="getConstant.mangeEmployees.editEmployeeBlankMsg.employeeFirstNameInvalidLengthMsg"></li>
            <li
              *ngIf="editRequestsForm.get('employeeLastName').invalid && editRequestsForm.get('employeeLastName').errors.required"
              [innerHTML]="getSharedConstant[businessUnit].employeeOrParticipantLastNameRequiredMsg"></li>
            <li
              *ngIf="editRequestsForm.get('employeeLastName').invalid && editRequestsForm.get('employeeLastName').errors.maxlength "
              [innerHTML]="getConstant.mangeEmployees.editEmployeeBlankMsg.employeeLastNameInvalidLengthMsg"></li>
          </ul>
        </div>
        <div *ngIf="sharedService.addOrEditEmployee !== 'addEployee' && serviceErrorMsg" class="sdps-text-l-body">
          <p *ngIf="serviceErrorMsg" [innerHTML]="serviceErrorMsg"></p>
        </div>
      </sdps-notification>
      <span class="sdps-text-l-bold-body sdps-pull-right" id="employee_AccountNumber">
        {{getConstant.mangeEmployees.editEmployeeBlankMsg.accountNumber}} : {{accountNumber | accountNumberFormat}}
      </span>
      <div class="sdps-grid-fluid sdps-wrap">
        <div class="sdps-row sdps-m-vertical_large sdps-wrap">
          <div class="sdps-row">
            <div class="col-content col-m-4 col-s-12 input-box" [ngClass]="{'invalidEmployee':invalidEmpId}">
              <p-floatlabel variant="in">
                <input type="text" name="employeeId" formControlName="employeeId" [maxLength]="35" emsEmployeeIdPatterncheck id="employeeId"
                  emsCharacterLimit [uppercaseRequired]="true" [charMaxLimit]="commonConstants.charLimitValues.thirtyFiveMaxLimit"
                  (emsCharacterLimitCheck)="showEmpIdCharLimit = $event" pInputText />
                <label for="employeeId">{{getSharedConstant[businessUnit].empOrParticipantsID}}
                  <span *ngIf="sharedService.addOrEditEmployee === 'addEployee'" class="sdps-text-market-red"
                    [innerHTML]="commonConstants.asterix"></span>
                </label>
              </p-floatlabel>
            </div>
          </div>
          <p class="col-4 sdps-text-right sdps-p-right_medium sdps-m-around_none sdps-text-small"
             *ngIf="editRequestsForm.get('employeeId').value && editRequestsForm.get('employeeId').value.trim().length > showEmpIdCharLimit">{{getConstant.rulesConstant.characterLimit}}
            <span class="character-limit">{{editRequestsForm.get('employeeId').value.trim().length}}
              /{{commonConstants.charLimitValues.thirtyFiveMaxLimit}}</span>
          </p>
        </div>

        <div class="sdps-p-right_medium">
          <div class="col-content col-m-4 col-s-12 input-box"
               [ngClass]="{'invalidEmployee':(editRequestsForm.controls['employeeFirstName'].value && editRequestsForm.get('employeeFirstName').invalid)}">

              <p-floatlabel variant="in">

              <input type="text" formControlName="employeeFirstName" [maxlength]="50" [uppercaseRequired]="true"
                     emsCharacterLimit [charMaxLimit]="commonConstants.charLimitValues.fiftyMaxLimit" id="employee_FirstName"
                     (emsCharacterLimitCheck)="showCharLimit = $event" pInputText/>
              <label for="employee_FirstName">
                {{getSharedConstant[businessUnit].empOrParticipantsFirstName}}
                <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
              </label>
              </p-floatlabel>
          </div>
          <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
             *ngIf="editRequestsForm.get('employeeFirstName').value && editRequestsForm.get('employeeFirstName').value.trim().length > showCharLimit">
            {{getConstant.rulesConstant.characterLimit}}
            <span class="character-limit">{{editRequestsForm.get('employeeFirstName').value.trim().length}}
              /{{commonConstants.charLimitValues.fiftyMaxLimit}}</span>
          </p>
        </div>

        <div>
          <div class="col-content col-m-4 col-s-12 input-box"
               [ngClass]="{'invalidEmployee':(editRequestsForm.controls['employeeLastName'].value ) && editRequestsForm.get('employeeLastName').invalid}">
               <p-floatlabel variant="in">
              <input type="text" formControlName="employeeLastName" emsCharacterLimit [uppercaseRequired]="true"
                     [charMaxLimit]="commonConstants.charLimitValues.fiftyMaxLimit"
                     (emsCharacterLimitCheck)="showCharLimit = $event" [maxlength]="50" pInputText id="employee_LastName"/>
              <label for="employee_LastName">
                {{getSharedConstant[businessUnit].empOrParticipantsLastName}}
                <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
              </label>
               </p-floatlabel>
          </div>
          <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
             *ngIf="editRequestsForm.get('employeeLastName').value && editRequestsForm.get('employeeLastName').value.trim().length > showCharLimit">
            {{getConstant.rulesConstant.characterLimit}}
            <span class="character-limit">{{editRequestsForm.get('employeeLastName').value.trim().length}}
              /{{commonConstants.charLimitValues.fiftyMaxLimit}}</span>
          </p>
        </div>
      </div>
    </form>
  </div>

  <div slot="modal-footer">
    <button class="buttons" type="reset" (click)="sharedService.closeModal('edit-employee-modal')"
              [innerHTML]="getConstant.rulesConstant.ruleGlobalConst.cancel" id="employee_cancelButton"></button>
    <button type="submit" (click)="updateEmployee()" [innerHTML]="getConstant.submitButton" class="buttons button-save"
            [disabled]="editRequestsForm.invalid || invalidEmpId || (sharedService.addOrEditEmployee === 'addEployee' && editRequestsForm.get('employeeId').value && editRequestsForm.get('employeeId').value.trim().length === 0) || editRequestsForm.get('employeeFirstName').value.trim().length === 0 || editRequestsForm.get('employeeLastName').value.trim().length === 0"
            id="employee_submitButton">
    </button>
  </div>
</sdps-modal>
